module.exports = __webpack_public_path__ + "static/img/Device.dda1009.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Device.svg
// module id = Jeky
// module chunks = 1